import { TabPanel, TabView } from "primereact/tabview";
import { PageProps } from "../../models/routing.model";
import { useTranslation } from "react-i18next";
import PastAppointments from "./PastAppointments";
import UpcomingAppointments from "./UpcomingAppointments";
import UiPageLayout from "../../components/page-layout/PageLayout.component";
import UiButton from "../../components/button/Button";
import { getLocalStorageUser } from "../../services/session/auth.service";
import { FiExternalLink } from "react-icons/fi";
import { useMatomo } from "@jonkoops/matomo-tracker-react";
import { MatomoAction, MatomoCategory } from "../../models/matomo.model";
import { useState } from "react";

const Appointments = (_props: PageProps) => {
	const { t } = useTranslation("common");
	const matomo = useMatomo();
	const [activeIndex, setActiveIndex] = useState<number>(0);

	return (
		<UiPageLayout
			title="APPOINTMENTS.TITLE"
			className="appointments-container"
			leftChildren={
				<UiButton
					id="bookAppointment"
					label="APPOINTMENTS.BUTTON_SCHEDULE"
					type="button"
					icon={<FiExternalLink className="p-button-icon p-button-icon-left" />}
					className="p-button-rounded p-button-sm"
					onClick={() => {
						matomo.trackEvent({
							category: MatomoCategory.APPOINTMENTS,
							action: MatomoAction.APPOINTMENTS_BOOKING,
						});
						window.open(getLocalStorageUser().schedulingLink, "_blank");
					}}
				/>
			}
			rightChildren={
				<TabView
					activeIndex={activeIndex}
					onTabChange={(e) => {
						console.log("TAB: ", e.index);
						setActiveIndex(e.index);
						if (e.index === 0) {
							matomo.trackEvent({
								category: MatomoCategory.APPOINTMENTS,
								action: MatomoAction.APPOINTMENTS_UPCOMING,
							});
						} else if (e.index === 1) {
							matomo.trackEvent({
								category: MatomoCategory.APPOINTMENTS,
								action: MatomoAction.APPOINTMENTS_COMLETED,
							});
						}
					}}
				>
					{/* Upcoming */}
					<TabPanel header={t("APPOINTMENTS.TAB_TITLE_UPCOMING")}>
						<UpcomingAppointments />
					</TabPanel>

					{/* Past */}
					<TabPanel header={t("APPOINTMENTS.TAB_TITLE_COMPLETED")}>
						<PastAppointments />
					</TabPanel>
				</TabView>
			}
		/>
	);
};
export default Appointments;
